import React, { useState, useEffect } from 'react';
import HelpTogal from '../TogelButton/HelpTogal';
import WebSliderServices from '../../services/WebSliderServices';

function WebSliderUpdate({ slider, closeModal, onSuccess }) {
  const [formValues, setFormValues] = useState({
    title: '',
    image: '',
    sequence: '',
    description: '',
  });
  const [previewImage, setPreviewImage] = useState('img/placeholder-img.png'); // Placeholder image path

  useEffect(() => {
    if (slider) {
      setFormValues({
        title: slider?.title || '',
        image: slider?.image || '',
        sequence: slider?.sequence || '',
        description: slider?.description || '',

      });
      if (slider.image) {
        setPreviewImage(process.env.REACT_APP_URL + slider.image);
      }
    }
  }, [slider]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result);
      };
      reader.readAsDataURL(file);
      setFormValues({
        ...formValues,
        image: file,
      });
    }
  };

  const handleSubmit = async (event) => {

    event.preventDefault();
    try {
      const formData = new FormData();
      console.log('jndasdj', formData);
      for (const key in formValues) {
        if (key !== 'image' || formValues[key] instanceof File) {
          formData.append(key, formValues[key]);
        }
      }

      await WebSliderServices.updateWebSlider(slider.id, formData);
      alert('Web slider updated successfully');
      onSuccess();
      closeModal();
    } catch (error) {
      console.error('Failed to update Web slider', error);
      alert('Failed to update Web slider');
    }
  };

  return (
    <div className="modal fade edit-box show d-block" id="editModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Edit WebSlider </h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" onClick={closeModal} aria-label="Close" />
          </div>
          <div className="modal-body">
            <div className="container-box px-5">
              <div className="container-box-inner table-reponsive-tabe">
                <div className="page-details">
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-lg-13 col-sm-12">
                        <div className="input-field">
                          <label>Title</label>
                          <input type="text" name="title" className="form-control" value={formValues.title} onChange={handleInputChange} placeholder="New title"  />
                        </div>
                      </div>

                      <div className="input-field">
                        <label>
                          Description <span className="red">*</span>
                        </label>

                        <textarea
                          name="description"
                          value={formValues.description}
                          onChange={handleInputChange}
                          placeholder="Enter description"
                          className="form-control"
                          rows="2"
                          
                        />
                      </div>
                      <div className="col-lg-12 col-md-12">
                        <div className="input-field">
                          <label>Select Sequence</label>
                          <select className="form-control" value={formValues.sequence} onChange={handleInputChange} name="sequence">
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                            <option value="4">4</option>
                            <option value="5">5</option>
                            <option value="6">6</option>
                          </select>
                        </div>
                      </div>

                      <div className="col-sm-9">
                        <div className="input-field">
                          <label>Upload<span className="red">*</span></label>
                          <input type="file" name="image" className="form-control" onChange={handleFileChange} />
                          <p><span>Drop an image or Paste URL (up to resolution 1,500 x 1,500 px),</span> Supported formats: png, jpeg, jpg, webp</p>
                          <div className="file-preview text-center">
                            <img id="uploadFile" src={previewImage} alt="your image" />
                          </div>
                        </div>
                      </div>

                    </div>
                    <button className="submit-green-btn">Submit</button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WebSliderUpdate;
